var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSectionBlockSmallMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 315 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M55 69.9385V80.9385H0V69.9385H55ZM315 59.1885H0V44.1885H315V59.1885ZM270 38.1885H0V23.1885H270V38.1885ZM102 12H0V0H102V12Z",
  fill: "#DFDFDF"
})));
export default SvgSectionBlockSmallMobile;